import React, { useContext} from 'react'
import { PatientCount } from './index'

const numberPatients = () => {
  const { patientCount, setPatientCount } = useContext(PatientCount);

  return(
    <>
      <div className="text-center row">
        <div className="col-md-1 col-sm-1"/>
          {
            [1,2,3,4,5].map((number) => {
              return (
                <div className="col-md-2 col-sm-2" key={"people_" + number}>
                  <button 
                    name="optradio" 
                    className="radio-button" 
                    id={"people_" + number}
                    data-dismiss="modal"
                    onClick ={() => setPatientCount(number)}
                  >
                   {number}名
                  </button>
                </div>  
              )
            })
          }
        <div className="col-md-1 col-sm-1"/>
      </div>  
      <div className="text-center row">
        <div className="col-md-1 col-sm-1"/>
          {
            [6,7,8,9,10].map((number) => {
              return (
                <div className="col-md-2 col-sm-2" key={"people_" + number}>
                  <button 
                    name="optradio" 
                    className="radio-button" 
                    id={"people_" + number}
                    data-dismiss="modal"
                    onClick ={() => setPatientCount(number)}
                  >
                   {number}名
                  </button>
                </div>  
              )
            })
          }
          <div className="col-md-1 col-sm-1"/>

      </div>
    </>
  )
}

export default numberPatients
